import React, { Component } from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react'

import store from '../store/'

const Container = styled.div`
  position: relative;
  z-index: 2;

  display: flex;
  padding: 0 5%;
  height: 100vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  transition: opacity 0.6s ease-in-out;
  opacity: ${props => props.opacity};

  @media (min-width: 992px) {
    padding: 0 17.7777777778%;
  }
`

const AboutHeader = styled.div`
  font-style: normal;
  font-weight: normal;
  line-height: 1.4;
  font-size: calc(40px / 1.5);

  color: #400b66;

  @media (min-width: 992px) {
    font-size: 40px;
  }
`

const AboutText = styled.div`
  margin-top: 53px;

  font-style: normal;
  font-weight: normal;
  line-height: 1.3333333333;
  font-size: calc(24px / 1.5);

  color: #400b66;

  @media (min-width: 992px) {
    font-size: 24px;
  }
`

@observer
export default class About extends Component {
  render() {
    return (
      <Container opacity={store.visibleSection.about ? 1 : 0}>
        <AboutHeader>
          Montreal-based Front-End Developer. Traveler, Guitar Rocker. 
          I build awesome products for my clients.
        </AboutHeader>

        <AboutText>
          I specialize in creating software that improves the lives of those 
          around me. I work with clients ranging from individuals and small businesses, 
          all the way to large enterprise corporations.
        </AboutText>
      </Container>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/About.js